import React from "react";

import { MyCollectablesWrapper } from "../../components";

export default function MyCollectablesPage() {
  return <MyCollectablesWrapper />;
}
